import { useNavigate } from 'react-router-dom'

import { Select } from '../../../../components/Primitives/Select'

type RouteOptions =
  | 'researcher'
  | 'client'
  | 'asset'
  | 'asset-analyst'
  | 'expert'
  | 'admin'

type Props = {
  defaultRoute: RouteOptions
}

const navigationOptions: Array<{ label: string, value: RouteOptions }> = [
  { label: 'Researcher', value: 'researcher' },
  { label: 'Cliente', value: 'client' },
  { label: 'Asset', value: 'asset' },
  { label: 'Analista Asset', value: 'asset-analyst' },
  { label: 'Expert', value: 'expert' },
  { label: 'Administradores', value: 'admin' },
]

export const NavigationSelect = ({ defaultRoute = 'expert' }: Props) => {
  const navigate = useNavigate()

  return (
    <div className="mb-6">
      <Select
        defaultValue={defaultRoute}
        onValueChange={(route) => navigate(`/painel/registers/${route}`)}
        options={navigationOptions}
      />
    </div>
  )
}
